import { Box, Button, CircularProgress } from '@mui/material'
import React from 'react'

const ButtonLoading = ({ loading, type, text }) => {
  return (
    <Box>
      {loading ? (
        <Button variant="contained">
          <CircularProgress size={24} color="inherit" />
        </Button>
      ) : (
        <Button
          type={type}
          variant="contained"
          disabled={loading}
        >
          {text}
        </Button>
      )}
    </Box>
  )
}

export default ButtonLoading